module.exports = __webpack_public_path__ + "img/iso1328-1-2013_figB02_second-order-profile-deviations.29ceb85b.png";